import { api } from "@/lib/api";

// "Gültig bis" ab Versandtag (Ralph 04.10.2026): Vor Drucken, Betterbird, .eml,
// Direktversand und Download wird ein Angebot einmalig festgeschrieben.
// Alte Angebote (ohne gueltig_ab_versand), Vorlagen und bereits festgeschriebene
// werden nie angefasst – das prüft zusätzlich auch das Backend.

const frageJaNein = (frage) => new Promise((resolve) => {
  const overlay = document.createElement("div");
  overlay.className = "fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4";
  overlay.setAttribute("data-testid", "festschreiben-dialog");
  const box = document.createElement("div");
  box.className = "bg-background rounded-lg shadow-xl w-full max-w-sm p-5";
  const text = document.createElement("p");
  text.className = "text-base font-semibold mb-4";
  text.textContent = frage;
  const buttons = document.createElement("div");
  buttons.className = "flex justify-end gap-2";
  const fertig = (wert) => { overlay.remove(); resolve(wert); };
  const nein = document.createElement("button");
  nein.type = "button";
  nein.className = "px-4 py-2 text-sm border rounded-sm hover:bg-muted";
  nein.textContent = "Nein";
  nein.setAttribute("data-testid", "btn-festschreiben-nein");
  nein.onclick = () => fertig(false);
  const ja = document.createElement("button");
  ja.type = "button";
  ja.className = "px-4 py-2 text-sm rounded-sm bg-primary text-primary-foreground hover:bg-primary/90";
  ja.textContent = "Ja";
  ja.setAttribute("data-testid", "btn-festschreiben-ja");
  ja.onclick = () => fertig(true);
  buttons.append(nein, ja);
  box.append(text, buttons);
  overlay.append(box);
  document.body.append(overlay);
  ja.focus();
});

const mussFestschreiben = (q) => !!q && q.gueltig_ab_versand === true && !q.is_template && !q.versendet_am;

// Gibt das aktuelle Angebot zurück (festgeschrieben oder unverändert).
export const angebotFestschreiben = async (quoteId) => {
  const { data: quote } = await api.get(`/quotes/${quoteId}`);
  if (!mussFestschreiben(quote)) return quote;
  const datumHeute = await frageJaNein("Angebotsdatum auf heute setzen?");
  const res = await api.post(`/quotes/${quoteId}/festschreiben`, { datum_heute: datumHeute });
  return res.data;
};
